import api from '@/api'

const namespaced = true

const state = () => ({
  all: [],
  statusDocuments: [],
  loading: false
})

const getters = {
  all: state => state.all,
  statusDocuments: state => state.statusDocuments,
  loading: state => state.loading
}

const mutations = {
  SET_ALL: (state, payload) => {
    state.all = payload
  },
  SET_STATUS_DOCUMENTS: (state, payload) => {
    state.statusDocuments = payload
  },
  SET_LOADING: (state, payload) => {
    state.loading = payload
  }
}

const actions = {
  async fetchAll({ commit }, payload) {
    try {
      commit('SET_LOADING', true)
      const { data } = await api.getTransactions(payload)
      commit('SET_ALL', data)
    } catch (err) {
      throw err.data || err.message
    } finally {
      commit('SET_LOADING', false)
    }
  },
  async fetchStatusDocuments({ commit }) {
    try {
      const { data } = await api.getStatusDocuments()
      commit('SET_STATUS_DOCUMENTS', data)
    } catch (err) {
      throw err.data || err.message
    }
  }
}

export default { namespaced, state, getters, mutations, actions }
